var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.364 9.778.293 2.708a1 1 0 0 1 1.414-1.415l7.071 7.071 7.071-7.071a1 1 0 0 1 1.414 1.414l-7.07 7.071 7.07 7.071a1 1 0 0 1-1.414 1.414l-7.07-7.07-7.072 7.07A1 1 0 0 1 .293 16.85z"
})));
export default SvgClose;